import { Header } from '../../common/header.component';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { Input } from '../../common/input.component';
import { required } from '../../../utils/validations';
import { AddButton } from '../../common/add-button';
import { DeliveryInsuranceService } from '../../../services/deliveryInsurance.service';
import { AlertService } from '../../../services/alert.service';
import { useLocation, useNavigate } from 'react-router-dom';
import { CleanDeliveryInsurance } from '../../../export-types/cleaned-types';
import React from 'react';
import { useSuppliers } from '../../../api/suppliers';
import { Select } from '../../common/select.component';

export type FormType = {
  disabled?: boolean;
  name: string;
  tariffs: Array<{
    pricePerKgFrom: string;
    pricePerKgTo: string;
    percent: string;
  }>;
  supplierId: number;
};

export const DeliveryInsuranceScreen = () => {
  const { data: suppliers } = useSuppliers();
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: CleanDeliveryInsurance };

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<FormType>({
    defaultValues: {
      ...{
        tariffs: [
          {
            pricePerKgFrom: '',
            pricePerKgTo: '',
            percent: '',
          },
        ],
      },
      ...state,
      supplierId: state?.supplier?.id,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'tariffs',
  });

  function onSave(deliveryInsurance: FormType) {
    const promise = state?.id
      ? DeliveryInsuranceService.updateDeliveryInsurance(
          deliveryInsurance,
          state.id,
        )
      : DeliveryInsuranceService.createDeliveryInsurance({
          ...deliveryInsurance,
          disabled: true,
        });
    promise.then(() => {
      AlertService.success();
      navigate('/deliveries/insurance');
    });
  }

  return (
    <>
      <Header />
      <div className="container" style={{ marginTop: -70 }}>
        <h1 className="mb-4">Добавить страховку</h1>
        <form onSubmit={handleSubmit(onSave)}>
          <Controller
            name="supplierId"
            control={control}
            rules={required}
            render={({ field }) => (
              <Select
                className="mb-3"
                title="Поставщик"
                placeholder="Выберите поставщика"
                options={
                  suppliers?.map(({ id, name }) => ({
                    value: id,
                    label: name,
                  })) ?? []
                }
                {...field}
                error={errors.supplierId?.message}
              />
            )}
          />
          <div className="mb-3">
            <Input
              title="Название страховки"
              {...register('name', {
                ...required,
              })}
              error={errors.name?.message}
            />
          </div>
          <h3>Тарифная сетка</h3>
          {fields.map((field, index) => (
            <div className="col-12 mb-3" key={field.id}>
              <div className="row align-items-start">
                <div className="col-8">
                  <div className="mb-2">Стоимость товара на 1 кг</div>
                  <div className="d-flex flex-row align-items-center">
                    <Input
                      className="flex-grow-1"
                      {...register(`tariffs.${index}.pricePerKgFrom`, {
                        ...required,
                      })}
                      type="number"
                      min={0}
                      step={1}
                      error={errors.tariffs?.[index]?.pricePerKgFrom?.message}
                      postfix="$"
                    />
                    <div className="ps-2 pe-2">—</div>
                    <Input
                      className="flex-grow-1"
                      {...register(`tariffs.${index}.pricePerKgTo`, {
                        ...required,
                      })}
                      type="number"
                      min={0}
                      step={1}
                      error={errors.tariffs?.[index]?.pricePerKgTo?.message}
                      postfix="$"
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="mb-2">% от стоимости товара</div>
                  <div className="d-flex flex-row align-items-center">
                    <Input
                      className="flex-grow-1"
                      {...register(`tariffs.${index}.percent`, {
                        ...required,
                      })}
                      type="number"
                      min={0}
                      step={0.01}
                      error={errors.tariffs?.[index]?.percent?.message}
                      postfix="%"
                    />
                    {index > 0 ? (
                      <i
                        className="bi bi-trash p-2 cursor-pointer hover-red"
                        onClick={() => remove(index)}
                      />
                    ) : (
                      <div style={{ width: 31 }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="mb-3">
            <AddButton
              onClick={() =>
                append({
                  percent: '',
                  pricePerKgTo: '',
                  pricePerKgFrom: '',
                })
              }
            >
              Добавить страховку
            </AddButton>
          </div>
          <button type="submit" className="btn btn-success w-100">
            Сохранить
          </button>
        </form>
      </div>
    </>
  );
};
